import React from 'react'
import { getProfilePhoto } from '../../../../helpers/image'
import './style.scss'

const InviteSteakHolders = ({
  landLordImage,
  landLord,
  tenantImage,
  tenant,
  thirdPartImage,
  thirdPart,
}) => {
  return (
    <div className='negotiation'>
      <div className='negotiation_content'>
        <img
          src={getProfilePhoto(landLordImage, landLord)}
          className='negotiation_user'
          alt='landloard'
        />

        <div className='negotiation_box'>
          <label className='negotiation_label'> {landLord}</label>
          <p className='negotiation_text'>Assina como dono do Imóvel</p>
        </div>
      </div>
      <div className='negotiation_content'>
        <img
          src={getProfilePhoto(tenantImage, tenant)}
          className='negotiation_user'
          alt='landloard'
        />

        <div className='negotiation_box'>
          <label className='negotiation_label'> {tenant}</label>
          <p className='negotiation_text'>Assina como parte no imóvel</p>
        </div>
      </div>
      {thirdPart && (
        <div className='negotiation_content'>
          <img
            src={getProfilePhoto(thirdPartImage, thirdPart)}
            className='negotiation_user'
            alt='landloard'
          />

          <div className='negotiation_box'>
            <label className='negotiation_label'> {thirdPart}</label>
            <p className='negotiation_text'>Assina como parte no imóvel</p>
          </div>
        </div>
      )}
    </div>
  )
}

// TODO: use ts
// InviteSteakHolders.propTypes = {
//   landLord: PropTypes.string,
//   landLordImage: PropTypes.string,
//   tenantImage: PropTypes.string,
//   tenant: PropTypes.string,
// }

export default InviteSteakHolders
